export const homePageName = 'home';
export const setPasswordPageName = 'set-password';
export const forgotPasswordPageName = 'forgot-password';
export const changePasswordPageName = 'change-password';
export const editProfilePageName = 'edit-profile';
export const loginPageName = 'login';
export const userManagementPageName = 'user-management';
export const dynamicUserManagementPageName = 'dynamic-user-management';
export const userEditPageName = 'user-edit';
export const clientAdministrationPageName = 'client-administration';
export const dynamicClientAdministrationPageName = 'dynamic-client-administration';
export const themeShowcasePageName = 'theme-showcase';
export const runningTotalsPageName = 'running-totals';
export const tripOverviewPageName = 'trip-overview';
export const statisticEventsPageName = 'statistic-events';
export const diagnosticEventsPageName = 'diagnostic-events';
export const periodicStatisticsPageName = 'periodic-statistics';
export const samplingProfilesPageName = 'sampling-profiles';
export const vehiclesPageName = 'vehicles';

